import React from 'react'
import ScrollingText from './ScrollingText'
import { SectionContainer } from '../../../../styles/common.style'
import { BackgroundImageLeft, BackgroundImageRight, EventsImagesContainer } from '../../../../styles/Homepage/BackgroundPictures.style'
import { HomeEventsSectionPictures } from '../../../../enums/images'
import { ScrollingTexts } from '../../../../enums/page_texts/homepage_texts'
import AvailableViews from '../../../../enums/views'

const EventsSection: React.FC = () => {
  return (
    <SectionContainer>
      <ScrollingText
        direction="left"
        href={AvailableViews.PrivateEvents}
        text={`${ScrollingTexts.Row1Text1} · ${ScrollingTexts.Row1Text2} · ${ScrollingTexts.Row1Text3}`}
      />
      <EventsImagesContainer>
        <BackgroundImageLeft src={HomeEventsSectionPictures.PrivateEventsPicture} alt="Private Events" />
        <BackgroundImageRight src={HomeEventsSectionPictures.PublicEventsPicture} alt="Public Events" />
      </EventsImagesContainer>
      <ScrollingText
        direction="right"
        href={AvailableViews.PublicEvents}
        text={`${ScrollingTexts.Row2Text1} · ${ScrollingTexts.Row2Text2} · ${ScrollingTexts.Row2Text3}`}
      />
    </SectionContainer>
  )
}

export default EventsSection
